import { inject } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { map } from "rxjs/operators";
import { FilerInformationService } from "../services";
import { SharedService } from "../../core";

export const AdminUserRequiredGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);

    const toPublic = router.createUrlTree(["public"]);
    const toSwitch = router.createUrlTree(["switch"], { queryParams: { returnUrl: state.url } });

    const shared = inject(SharedService);

    return inject(FilerInformationService).current$.pipe(
        map((filer) => {
            if (shared.isAdminUser()) return true;
            if (!filer) return toSwitch;

            return toPublic;
        })
    );
}